{#if $isUserLoggedIn}
<div class="community-page">

  <FocusRestoration realm="community">
    <RadioGroup
      id="pinnables"
      length={numPinnable}
      label="Pinnable timelines">

      <h2 class="community-header">
        Timelines
      </h2>

      <PageList label="Timelines">
        {#each staticPinnables as staticPinnable, i}
          <PageListItem href={staticPinnable.href}
                        label={staticPinnable.label}
                        icon={staticPinnable.icon}
                        pinnable="true"
                        pinIndex={i}
          />
        {/each}
      </PageList>

      {#if listsLength}

        <h2 class="community-header">
          Lists
        </h2>

        <PageList label="Lists">
          {#each $lists as list, i}
            <PageListItem href="/lists/{list.id}"
                          label={list.title}
                          icon="#fa-bars"
                          pinnable="true"
                          pinIndex={staticPinnablesLength + i}
            />
          {/each}
        </PageList>

      {/if}

    </RadioGroup>

    <h2 class="community-header">
      Instance settings
    </h2>

    <PageList label="Instance settings">
      {#if isLockedAccount}
      <PageListItem href="/requests"
                    label={followRequestsLabel}
                    icon="#fa-user-plus"
       />
      {/if}
      <PageListItem href="/muted"
                    label="Muted users"
                    icon="#fa-volume-off"
      />
      <PageListItem href="/blocked"
                    label="Blocked users"
                    icon="#fa-ban"
      />
      <PageListItem href="/pinned"
                    label="Pinned toots"
                    icon="#fa-thumb-tack"
      />
    </PageList>

  </FocusRestoration>
</div>
{:else}
<HiddenFromSSR>
  <FreeTextLayout>
    <h1>Community</h1>

    <p>Community options appear here when logged in.</p>
  </FreeTextLayout>
</HiddenFromSSR>
<div style="display: none">
  <!-- TODO: this is just a hack so that `sapper export` knows to crawl these files -->
  <!-- Note that these links have to be spread out or else they result in ECONNRESET errors during crawling -->
  <!-- See also search.html -->
  <a href="/requests">Follow requests</a>
  <a href="/muted">Muted users</a>
  <a href="/blocked">Blocked users</a>
  <a href="/pinned">Pinned toots</a>
</div>
{/if}
<style>
  .community-page {
    margin: 20px;
  }
  @media (max-width: 767px) {
    .community-page {
      margin: 20px 10px;
    }
  }
</style>
<script>
  import FreeTextLayout from '../../_components/FreeTextLayout.html'
  import { store } from '../../_store/store.js'
  import HiddenFromSSR from '../../_components/HiddenFromSSR.html'
  import PageList from '../../_components/community/PageList.html'
  import PageListItem from '../../_components/community/PageListItem.html'
  import RadioGroup from '../../_components/radio/RadioGroup.html'
  import { updateListsForInstance } from '../../_actions/lists.js'
  import { updateFollowRequestCountIfLockedAccount } from '../../_actions/followRequests.js'
  import FocusRestoration from '../../_components/FocusRestoration.html'
  import { formatIntl } from '../../_utils/formatIntl.js'

  export default {
    async oncreate () {
      const { currentInstance } = this.store.get()
      if (currentInstance) {
        await Promise.all([
          updateListsForInstance(currentInstance),
          updateFollowRequestCountIfLockedAccount(currentInstance)
        ])
      }
    },
    store: () => store,
    components: {
      FreeTextLayout,
      HiddenFromSSR,
      PageList,
      PageListItem,
      RadioGroup,
      FocusRestoration
    },
    data: () => ({
      staticPinnables: [
        {
          href: '/local',
          label: "Local timeline",
          icon: '#fa-users'
        },
        {
          href: '/federated',
          label: "Federated timeline",
          icon: '#fa-globe'
        },
        {
          href: '/favorites',
          label: "Favorites",
          icon: '#fa-star'
        },
        {
          href: '/direct',
          label: "Direct messages",
          icon: '#fa-envelope'
        },
        {
          href: '/bookmarks',
          label: "Bookmarks",
          icon: '#fa-bookmark'
        }
      ]
    }),
    computed: {
      isLockedAccount: ({ $currentVerifyCredentials }) => $currentVerifyCredentials && $currentVerifyCredentials.locked,
      followRequestsLabel: ({ $hasFollowRequests, $numberOfFollowRequests }) => (
        formatIntl(["Follow requests ",["hasFollowRequests","select",{"true":["(",["count"],")"],"other":[]}]], {
          hasFollowRequests: $hasFollowRequests,
          count: $numberOfFollowRequests
        })
      ),
      listsLength: ({ $lists }) => $lists ? $lists.length : 0,
      staticPinnablesLength: ({ staticPinnables }) => staticPinnables.length,
      numPinnable: ({ listsLength, staticPinnablesLength }) => listsLength + staticPinnablesLength
    }
  }
</script>
